function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'azzurro': 'rgb(84, 111, 158)','cobalto': 'rgb(48, 164, 214)','beige': 'rgb(214, 198, 165)','bianco': 'rgb(255, 255, 255)','bordeaux': 'rgb(127, 29, 29)','vinaccia': 'rgb(76, 11, 28)','blu': 'rgb(22, 26, 53)','blu-marinaio': 'rgb(21, 26, 65)','giallo': 'rgb(250, 204, 21)','grigio': 'rgb(156, 163, 175)','marrone': 'rgb(123, 94, 71)','nero': 'rgb(0, 0, 0)','rosso': 'rgb(198, 40, 40)','verde': 'rgb(65, 73, 60)','verde-predatore': 'rgb(76, 94, 58)','cityscape': 'rgb(14, 111, 153)','arancione': 'rgb(214, 86, 48)',};

    this.images = {'giallo-marrone': 'url("//www.dynamoshop.it/cdn/shop/files/yb_120x.png?v=16851791075650269365")','nero-blu': 'url("//www.dynamoshop.it/cdn/shop/files/bb_120x.png?v=13422744179842405443")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
